
import { PanelBar, PanelBarItem } from "@progress/kendo-react-layout";
import React from "react";
import { Api } from "../../../redux/api/BaseApi";
import { TicketApi } from "../../../redux/api/TicketApi";
import { useReduxDispatch, useReduxSelector } from "../../../redux/hooks";

import { ITemplateListItem } from "../../../types/Ticket/ITemplate";
import { TemplateList } from "../ListControls/TemplateList";
import * as TicketSlice from "../../../slices/TicketSlice";
import TemplateActions from "./TemplateActions";

const Templates: React.FC = (props) => {
    const { data: userProfile } = Api.useGetUserProfileQuery();
    const dispatch = useReduxDispatch();
    const { ticket } = useReduxSelector(state => state.newTicket);
    const { data: template } = TicketApi.useGetTemplateQuery(ticket?.Template_Id, { skip: !ticket?.Template_Id });


    const onTemplateChanged = (e: { value: ITemplateListItem; }) => {
        dispatch(TicketSlice.SetTemplatePopulated(false))
        dispatch(TicketSlice.SetTemplate(e.value))

        //console.log('After dispatch', template?.ID, ticket.Template_Id)
    }
    const title = userProfile?.Features.Call_Templates && userProfile?.Features.Workflow
        ? `Templates & Workflows`
        : userProfile?.Features.Call_Templates ? 'Templates' : userProfile?.Features.Workflow ? 'Workflows' : '...'

    return (
        <PanelBar>
            <PanelBarItem selected={true} expanded={true} title={title} >
                <div className="mb-3">
                    <TemplateList onChange={onTemplateChanged} templateId={ticket.Template_Id} hasDescription={ticket?.Call_Desc?.length > 0} />
                </div>
                <TemplateActions templateId={ticket.Template_Id} isWorkflow={template?.IsWorkflow} />
            </PanelBarItem>
        </PanelBar>
    )
}

export default Templates;